import { IconWithGradient } from 'design-system/icons/Icon';
import * as React from 'react';
import { Path } from 'react-native-svg';
export const IconArrowBack = ({ ...props }) => {
    const id = React.useId();
    return (<IconWithGradient id={id} defaultGradientKey="skyBlue" width={19} height={19} fill="none" viewBox="0 0 19 19" {...props}>
      <Path d="M8.77 1c-2.65.07-5 1.28-6.6 3.16L.85 2.85a.5.5 0 0 0-.85.36V7.5c0 .28.22.5.5.5h4.29c.45 0 .67-.54.35-.85L3.59 5.59C4.88 4.02 6.82 3 9 3c4.32 0 7.74 3.94 6.86 8.41-.54 2.77-2.81 4.98-5.58 5.47-3.8.68-7.18-1.74-8.05-5.16-.12-.42-.52-.72-.96-.72-.65 0-1.14.61-.98 1.23C1.28 16.12 4.8 19 9 19c5.06 0 9.14-4.17 9-9.26C17.86 4.86 13.65.88 8.77 1ZM11 10c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2Z" fill={`url(#gradient_${id})`}/>
    </IconWithGradient>);
};
